import React from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

import { useStyles } from './styles'

export default ({ coach, actions }) => {
  const classes = useStyles()
  const { id, name, facilityName, coachAvatar } = coach

  return (
    <Card key={id} className={classes.root} variant="outlined">
      <CardContent className={classes.coachInfo}>
        <Avatar className={classes.coachAvatar} alt={name} src={coachAvatar}>
          {name.substring(0, 1)}
        </Avatar>
        <div>
          <Typography variant="body1">{name}</Typography>
          {facilityName ? (
            <Typography variant="caption">{facilityName}</Typography>
          ) : null}
        </div>
      </CardContent>
      {actions ? (
        <CardActions disableSpacing className={classes.actionBar}>
          {actions}
        </CardActions>
      ) : null}
    </Card>
  )
}
